import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { Account } from '../../models/account.model';
import { ApiService } from '../../services/api/api.service';
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'morph-menu',
  templateUrl: './morph-menu.component.html',
  styleUrls: ['./morph-menu.component.less'],
})
export class MorphMenuComponent implements OnInit {
  accounts: Account[] = [];
  selectedAccount: Account | null = null;
  hubHostname: string;
  isBurtAdmin: boolean = false;

  constructor(
    private apiService: ApiService,
    private sessionService: SessionService,
  ) {
    const parts = window.location.hostname.split('.').slice(1);
    this.hubHostname = `//${parts.join('.')}`;
    this.isBurtAdmin = this.sessionService.user?.role === 'burt_admin';
  }

  public ngOnInit() {
    if (this.isBurtAdmin) {
      this.loadAccounts();
    }
  }

  private loadAccounts() {
    this.apiService.load('/session/accounts').pipe(take(1)).subscribe(
      (accounts: Account[]) => {
        this.accounts = accounts.sort((a, b) => a.name.localeCompare(b.name));
        this.selectedAccount = accounts.find(account => account.id === this.sessionService.account.id) || null;
      },
    );
  }

  public onAccountSelect(account: Account) {
    const protocol = window.location.protocol;
    const url = `${protocol}//${this.hubHostname}/hub/morph/${account.id}/burt_admin?r=${window.location}`;
    window.location.href = url;
  }
}
